<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card class="elevation-2">
              <v-toolbar dark color="blue-grey darken-4">
                <v-toolbar-title>Fulfillment</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
<!--              error bar-->
              <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-layout>
              <v-card-text v-if="fulfillments !==null">
                <v-list-item
                    three-line
                    v-for="fulfillment in fulfillments"
                    :key="fulfillment.id"
                    @click="routeToFulfillment(fulfillment.id)">
                  <v-list-item-content>
                    <v-list-item-title
                        v-if="fulfillment.date"
                    >{{momentDate(fulfillment.date)}}</v-list-item-title>
                    <v-list-item-subtitle v-if="fulfillment.crewMeetupLocation">
                      {{fulfillment.crewMeetupLocation.name}}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{fulfillment.id}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import moment from "moment"
import { getDocs, query, orderBy, collection, limit} from "firebase/firestore"
export default {
  data: () => ({
    fulfillments: null,
    lastDoc: null,

  }),
  computed: {
    momentDate() {
      return (date) => {
        return moment(date).format('dddd, LL')
      }
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created() {
    let db = this.$store.state.db
    let fulfillmentRef = collection(db, 'serviceProviders', this.user.phoneNumber + '/fulfillment')
    let fulfillmentQuery = query(fulfillmentRef, orderBy('date', "desc"), limit(25))

    getDocs(fulfillmentQuery)
        .then(res => {
          let orders = []
          if(!res.empty) {
            res.forEach(doc => {
              let data = doc.data()
              data.id = doc.id
              orders.push(data)
            })
            this.fulfillments = orders
            console.log(this.fulfillments)
            this.lastDoc = orders[res.docs.length-1]
          }
          return this.$store.dispatch('setLoading', false)
        })
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    routeToFulfillment (fulfillmentId) {
      this.$router.push('/fulfillment/' + fulfillmentId)
    }
  }

}
</script>

